// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("docavea_icon_font.ttf?7232rq", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'docavea';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'docavea' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-label-filled:before {
  content: "\\e93b";
}
.icon-label-color:before {
  content: "\\e93a";
}
.icon-label-color-80:before {
  content: "\\e900";
}
.icon-label-color-90:before {
  content: "\\e939";
}
.icon-edit-list:before {
  content: "\\e901";
}
.icon-dual-viewer:before {
  content: "\\e902";
}
.icon-doc:before {
  content: "\\e903";
}
.icon-bundle3:before {
  content: "\\e904";
}
.icon-bundle4:before {
  content: "\\e905";
}
.icon-report-box:before {
  content: "\\e906";
}
.icon-report-box1:before {
  content: "\\e907";
}
.icon-category:before {
  content: "\\e908";
}
.icon-logo:before {
  content: "\\e909";
}
.icon-add:before {
  content: "\\e90a";
}
.icon-broken-doc:before {
  content: "\\e90b";
}
.icon-checkbox-blank:before {
  content: "\\e90c";
}
.icon-checkbox:before {
  content: "\\e90d";
}
.icon-comments-right:before {
  content: "\\e90e";
}
.icon-comments:before {
  content: "\\e90f";
}
.icon-delete:before {
  content: "\\e910";
}
.icon-document-left:before {
  content: "\\e911";
}
.icon-document-right:before {
  content: "\\e912";
}
.icon-extract-box:before {
  content: "\\e913";
}
.icon-extract3:before {
  content: "\\e914";
}
.icon-extract4:before {
  content: "\\e915";
}
.icon-hourglass:before {
  content: "\\e916";
}
.icon-label:before {
  content: "\\e917";
}
.icon-lock-open:before {
  content: "\\e918";
}
.icon-lock:before {
  content: "\\e919";
}
.icon-match-case:before {
  content: "\\e91a";
}
.icon-match-words:before {
  content: "\\e91b";
}
.icon-move:before {
  content: "\\e91c";
}
.icon-orientation:before {
  content: "\\e91d";
}
.icon-overview-left:before {
  content: "\\e91e";
}
.icon-overview:before {
  content: "\\e91f";
}
.icon-page-back:before {
  content: "\\e920";
}
.icon-page-end:before {
  content: "\\e921";
}
.icon-page-forward:before {
  content: "\\e922";
}
.icon-page-jump-back:before {
  content: "\\e923";
}
.icon-page-jump-forward:before {
  content: "\\e924";
}
.icon-page-start:before {
  content: "\\e925";
}
.icon-pagemode-cover:before {
  content: "\\e926";
}
.icon-pagemode-dual:before {
  content: "\\e927";
}
.icon-pagemode-single:before {
  content: "\\e928";
}
.icon-password-hide:before {
  content: "\\e929";
}
.icon-password-key:before {
  content: "\\e92a";
}
.icon-password-show:before {
  content: "\\e92b";
}
.icon-pencil:before {
  content: "\\e92c";
}
.icon-rectangle:before {
  content: "\\e92d";
}
.icon-redo:before {
  content: "\\e92e";
}
.icon-search:before {
  content: "\\e92f";
}
.icon-settings:before {
  content: "\\e930";
}
.icon-split-doc:before {
  content: "\\e931";
}
.icon-thumbnails-hide:before {
  content: "\\e932";
}
.icon-thumbnails-show:before {
  content: "\\e933";
}
.icon-undo:before {
  content: "\\e934";
}
.icon-user:before {
  content: "\\e935";
}
.icon-zoom-page:before {
  content: "\\e936";
}
.icon-zoom-percent:before {
  content: "\\e937";
}
.icon-zoom-width:before {
  content: "\\e938";
}
`, "",{"version":3,"sources":["webpack://./assets/docavea_icon_font.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gEAA4D;EAC5D,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'docavea';\n  src:  url('docavea_icon_font.ttf?7232rq') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'docavea' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-label-filled:before {\n  content: \"\\e93b\";\n}\n.icon-label-color:before {\n  content: \"\\e93a\";\n}\n.icon-label-color-80:before {\n  content: \"\\e900\";\n}\n.icon-label-color-90:before {\n  content: \"\\e939\";\n}\n.icon-edit-list:before {\n  content: \"\\e901\";\n}\n.icon-dual-viewer:before {\n  content: \"\\e902\";\n}\n.icon-doc:before {\n  content: \"\\e903\";\n}\n.icon-bundle3:before {\n  content: \"\\e904\";\n}\n.icon-bundle4:before {\n  content: \"\\e905\";\n}\n.icon-report-box:before {\n  content: \"\\e906\";\n}\n.icon-report-box1:before {\n  content: \"\\e907\";\n}\n.icon-category:before {\n  content: \"\\e908\";\n}\n.icon-logo:before {\n  content: \"\\e909\";\n}\n.icon-add:before {\n  content: \"\\e90a\";\n}\n.icon-broken-doc:before {\n  content: \"\\e90b\";\n}\n.icon-checkbox-blank:before {\n  content: \"\\e90c\";\n}\n.icon-checkbox:before {\n  content: \"\\e90d\";\n}\n.icon-comments-right:before {\n  content: \"\\e90e\";\n}\n.icon-comments:before {\n  content: \"\\e90f\";\n}\n.icon-delete:before {\n  content: \"\\e910\";\n}\n.icon-document-left:before {\n  content: \"\\e911\";\n}\n.icon-document-right:before {\n  content: \"\\e912\";\n}\n.icon-extract-box:before {\n  content: \"\\e913\";\n}\n.icon-extract3:before {\n  content: \"\\e914\";\n}\n.icon-extract4:before {\n  content: \"\\e915\";\n}\n.icon-hourglass:before {\n  content: \"\\e916\";\n}\n.icon-label:before {\n  content: \"\\e917\";\n}\n.icon-lock-open:before {\n  content: \"\\e918\";\n}\n.icon-lock:before {\n  content: \"\\e919\";\n}\n.icon-match-case:before {\n  content: \"\\e91a\";\n}\n.icon-match-words:before {\n  content: \"\\e91b\";\n}\n.icon-move:before {\n  content: \"\\e91c\";\n}\n.icon-orientation:before {\n  content: \"\\e91d\";\n}\n.icon-overview-left:before {\n  content: \"\\e91e\";\n}\n.icon-overview:before {\n  content: \"\\e91f\";\n}\n.icon-page-back:before {\n  content: \"\\e920\";\n}\n.icon-page-end:before {\n  content: \"\\e921\";\n}\n.icon-page-forward:before {\n  content: \"\\e922\";\n}\n.icon-page-jump-back:before {\n  content: \"\\e923\";\n}\n.icon-page-jump-forward:before {\n  content: \"\\e924\";\n}\n.icon-page-start:before {\n  content: \"\\e925\";\n}\n.icon-pagemode-cover:before {\n  content: \"\\e926\";\n}\n.icon-pagemode-dual:before {\n  content: \"\\e927\";\n}\n.icon-pagemode-single:before {\n  content: \"\\e928\";\n}\n.icon-password-hide:before {\n  content: \"\\e929\";\n}\n.icon-password-key:before {\n  content: \"\\e92a\";\n}\n.icon-password-show:before {\n  content: \"\\e92b\";\n}\n.icon-pencil:before {\n  content: \"\\e92c\";\n}\n.icon-rectangle:before {\n  content: \"\\e92d\";\n}\n.icon-redo:before {\n  content: \"\\e92e\";\n}\n.icon-search:before {\n  content: \"\\e92f\";\n}\n.icon-settings:before {\n  content: \"\\e930\";\n}\n.icon-split-doc:before {\n  content: \"\\e931\";\n}\n.icon-thumbnails-hide:before {\n  content: \"\\e932\";\n}\n.icon-thumbnails-show:before {\n  content: \"\\e933\";\n}\n.icon-undo:before {\n  content: \"\\e934\";\n}\n.icon-user:before {\n  content: \"\\e935\";\n}\n.icon-zoom-page:before {\n  content: \"\\e936\";\n}\n.icon-zoom-percent:before {\n  content: \"\\e937\";\n}\n.icon-zoom-width:before {\n  content: \"\\e938\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
